<template>
    <div class="review-assessment">
        <div class="review-assessment__header">
            <div>
                <img src="@/assets/images/expert-panel/assessment.svg" />
            </div>
            <div class="review-assessment__title">
                Оценочный лист
            </div>
        </div>
        <div class="review-assessment__body">
            <div v-for="score of review.reviewScores" :key="score.id">
                <ExpertPanelReviewAssessmentScore
                    v-if="score.scoreType === SCORE_TYPE_SCORE"
                    :score="score"
                    :readonly="readonly"
                    v-model="scores[score.id]"
                    @completed="completed = {...completed, [score.id]: $event}"
                />
                <ExpertPanelReviewAssessmentCriteria
                    v-else
                    :score="score"
                    :readonly="readonly"
                    v-model="scores[score.id]"
                    @completed="completed = {...completed, [score.id]: $event}"
                />
            </div>
            <ExpertPanelReviewAssessmentCommentForm
                v-model="form"
                :readonly="readonly"
                :saving="saving"
                :completed="isCompleted"
                @submit="save"
            />
        </div>
    </div>
</template>

<script>
import ExpertPanelReviewAssessmentScore
    from "@/components/expert-panel-new/review/ExpertPanelReviewAssessmentScore.vue";
import ExpertPanelReviewAssessmentCriteria
    from "@/components/expert-panel-new/review/ExpertPanelReviewAssessmentCriteria.vue";
import ExpertPanelReviewAssessmentCommentForm
    from "@/components/expert-panel-new/review/ExpertPanelReviewAssessmentCommentForm.vue";
import { SCORE_TYPE_SCORE } from "@/consts/scoreTypes";
import { post } from "@/tools/http";
import App from "@/main";
import { REVIEW_SESSION_STATUS_COMPLETED, REVIEW_SESSION_STATUS_NEW } from "@/consts/examination";
import getApi from "@/tools/api/examination";

export default {
    name: "ExpertPanelReviewAssessment",
    components: {
        ExpertPanelReviewAssessmentCommentForm,
        ExpertPanelReviewAssessmentCriteria,
        ExpertPanelReviewAssessmentScore,
    },
    props: {
        review: Object,
        session: Object,
        readonly: Boolean,
    },
    data() {
        return {
            scores: {},
            form: {
                comment: '',
                finish: false,
            },
            completed: {},
            saving: false,
            SCORE_TYPE_SCORE,
            examinationApi: getApi(),
        };
    },
    computed: {
        isCompleted() {
            return Object.values(this.completed).filter((val) => !val).length === 0;
        },
    },
    methods: {
        initScores(session) {
            this.scores = session.reviewSessionScores.reduce((result, reviewSessionScore) => {
                if (reviewSessionScore.scoreType === SCORE_TYPE_SCORE) {
                    result[reviewSessionScore.reviewScoreId] = `${reviewSessionScore.score}`;
                } else {
                    if (result[reviewSessionScore.reviewScoreId] === undefined) {
                        result[reviewSessionScore.reviewScoreId] = {};
                    }
                    result[reviewSessionScore.reviewScoreId][reviewSessionScore.criteriaId] = reviewSessionScore.relationId;
                }
                return result;
            }, {});
            this.form = {
                comment: session.comment,
                finish: false,
            };
        },
        postData() {
            return {
                scores: Object.keys(this.scores).reduce((res, scoreId) => {
                    const score = this.review.reviewScores.find((row) => row.id === +scoreId);
                    if (score) {
                        if (score.scoreType === SCORE_TYPE_SCORE) {
                            res.push({
                                reviewSessionId: this.session.id,
                                reviewScoreId: +scoreId,
                                reviewScoreCriteriaId: null,
                                score: +this.scores[scoreId],
                            });
                        } else {
                            Object.keys(this.scores[scoreId]).forEach((row) => {
                                res.push({
                                    reviewSessionId: this.session.id,
                                    reviewScoreId: +scoreId,
                                    criteriaId: +row,
                                    relationId: +this.scores[scoreId][row],
                                });
                            });
                        }
                    }
                    return res;
                }, []),
                comment: this.form.comment,
                status: this.form.finish ? REVIEW_SESSION_STATUS_COMPLETED : REVIEW_SESSION_STATUS_NEW,
            };
        },
        async save() {
            const params = this.postData();
            this.saving = true;
            const res = await this.examinationApi.saveSession(this.review.id, this.session.activitySession.id, params);
            this.saving = false;
            if (res !== null) {
                this.$noty.success('Данные сохранены успешно');
                if (this.form.finish) {
                    this.$router.push({
                        name: 'expert-panel-event',
                        params: {
                            type: 'review',
                            event: this.review.id,
                        },
                    });
                }
            } else {
                this.$noty.error('Ошибка');
            }
        },
    },
    created() {
        this.initScores(this.session);
    },
};
</script>

<style lang="scss" scoped>
@import '@/styles/rem';

.review-assessment {
  font-family: Montserrat, sans-serif;
  box-shadow: 0 rem(2) rem(16) rgba(70, 99, 171, 0.16);
  border-radius: rem(16);
  overflow: hidden;
  background: #E1F4E4;
  &__header {
    display: flex;
    align-items: center;
    gap: rem(10);
    padding: rem(20) rem(40);
  }
  &__title {
    font-weight: 600;
    font-size: rem(20);
    line-height: rem(34);
    color: #2A2626;
  }
  &__body {
    background: #fff;
    padding: rem(32) rem(40);
    display: flex;
    flex-direction: column;
    gap: rem(32);
  }
}


</style>